import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-filedrop-popup',
    templateUrl: './filedrop-popup.component.html',
    styleUrl: './filedrop-popup.component.scss',
    standalone: false
})
export class FiledropPopupComponent {
  @Input() message: string = "Drop files here to upload them to the project."
  @Output() fileDropped = new EventEmitter<FileList>();
  @Output() hideDropPopup = new EventEmitter<void>();
  public isDragOver = false; // New property to track the drag state
  originalMessage = ""
  isCloseButtonVisible = false
  fileList: FileList = new DataTransfer().files;

  /** Array view of fileList for template iteration (FileList is not iterable). */
  get filesArray(): File[] {
    return Array.from(this.fileList);
  }

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  
  ngOnInit() {
    this.originalMessage = this.message
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    // Optionally add a class to highlight the drop area
    this.isDragOver = true; // Set to true when dragging over
    this.message = "Drop now."
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    this.message = "Wait while the files are uploaded..."
    if (files && files.length > 0) {
      this.handleFiles(files);
    }
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false; // Reset the drag state
    this.message = this.originalMessage
  }

  handleFiles(files: FileList) {
    this.fileDropped.emit(files);
  }

  close() {
    const emptyFileList = this.createEmptyFileList();
    this.fileDropped.emit(emptyFileList);
    this.hideDropPopup.emit();
  }
  
  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      this.fileList = this.convertToFileList(files);
    //  this.fileDropped.emit(fileList);
    console.log(this.fileList);
    } else {
      this.message = this.originalMessage
    }
  }

  private convertToFileList(files: File[]): FileList {
    const dataTransfer = new DataTransfer();
    files.forEach(file => dataTransfer.items.add(file));
    return dataTransfer.files;
  }

  private createEmptyFileList(): FileList {
    const dataTransfer = new DataTransfer();
    return dataTransfer.files;
  }

  uploadFiles() {
    console.log(this.fileList);
    this.fileDropped.emit(this.fileList);
  }

  deleteFile(file: File) {
    this.fileList = this.convertToFileList(this.filesArray.filter((f: File) => f !== file));
  }

}
